import { useInfiniteQuery } from "@tanstack/react-query";

import { getProducts } from "../../api/catalog";

export interface UseProductsParams {
  categoryId?: string;
  search?: string;
}

/**
 * useProducts — страницы товаров каталога с курсорной пагинацией
 * (docs/07-miniapp-ux.md §2.2: по 20 товаров, бесконечный скролл; §3: staleTime 30с).
 */
export function useProducts({ categoryId, search }: UseProductsParams) {
  return useInfiniteQuery({
    queryKey: ["products", { categoryId, search }],
    queryFn: ({ pageParam, signal }) => getProducts({ categoryId, search, cursor: pageParam }, signal),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.next_cursor,
    staleTime: 30_000,
  });
}
